import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simmetrica',
  templateUrl: './simmetrica.component.html',
  styleUrls: ['./simmetrica.component.css']
})
export class SimmetricaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
